import { useContext, useState } from "react"
import { notify } from "../../utils/utils";
import { Fetch } from "../../services/api";
import { UserContext } from "../../context/provider/UserProvider";

const urlProyecto  = process.env.REACT_APP_XPROJECT_API + '/Task'
export const useTareas = () => {
    const { stateUser } = useContext(UserContext);
    const tareaDefault = {
        descripcionTarea: '',
        codTicketActividad: 0,
    }
    const [ nuevaTarea, setNuevaTarea ] = useState(tareaDefault);
    const [ tareas, setTareas ] = useState([]);
    const [ ticketEntregable, setTicketEntregable ] = useState([]); 
    const [ actividadUsuario, setActividadUsuario ] = useState([]);
    const [ detalleTicket, setDetalleTicket ] = useState([{nomTicket:'',codTicket:0,nomEntregable:'',alcance:'',objetivo:''}])

    const listarTareas = async (codTicketActividad) => {
        try
        {
            const response = await Fetch({
                url: urlProyecto + '?' + new URLSearchParams({
                    codTicketActividad: codTicketActividad,
                })
            })
            !response.isValid && notify(response.exceptions[0].description, 'error');
            setTareas(response.isValid ? response.content : []);
        }
        catch(e)
        {
            notify('Ocurrió un error en el servicio', 'error');
            console.log('Error al listar tareas: ',e);
        }
    }

    const editarValorNuevaTarea = (key, value) => {
        setNuevaTarea( tarea => {
            return {
                ...tarea,
                [key]: value
            }
        })
    }

    const registrarTarea = async (indice) => {
        try{
            const esGuardar = indice === undefined ? true : false;
            const response = await Fetch({
                url: urlProyecto ,
                method: esGuardar ? 'POST' : 'PUT',
                body: JSON.stringify({
                    ...(esGuardar ?
                        {
                            DescripcionTarea: nuevaTarea.descripcionTarea,
                            CodTicketActividad: nuevaTarea.codTicketActividad,
                        }
                        :
                        {
                            CodTicketTarea: parseInt(tareas[indice].codTicketTarea),
                            DescripcionTarea: tareas[indice].descripcionTarea
                        }
                    ),
                    codUsuarioAccion: stateUser.codUsuario
                })
            })
            notify((response.isValid ? response.content : response.exceptions[0].description), response.isValid ? 'success' : 'error')
            return response.isValid
        }
        catch(e)
        {
            console.log('Error al registrar tarea: ',e);
            notify('Ocurrío un error en el servicio','error');
            return false
        }
    }
    
    const editarValorTarea = (index,key, value) => {
        setTareas((tareas) =>
            tareas.map((tarea, i) =>
                i === index
                    ? { ...tarea, [key]: value } // Actualiza solo la tarea específica
                    : tarea // Mantén las demás tareas sin cambios
            )
        );
    }

    const listarTicketEntregable = async (CodTicketTipo) => {
        try
        {
            const response = await Fetch({
                url: urlProyecto + '/ticket?' + new URLSearchParams({
                    CodUsuarioAccion: 50,//stateUser.codUsuario,
                    CodTicketTipo: CodTicketTipo,
                })
            })
            !response.isValid && notify(response.exceptions[0].description, 'error');
            setTicketEntregable(response.isValid ? response.content : []);
        }
        catch(e)
        {

        }
    }

    const listaActividadPorUsuario = async () => {
        try
        {
            const response = await Fetch({
                url: urlProyecto + '/activityUser?' + new URLSearchParams({
                    CodUsuarioAccion: stateUser.codUsuario,
                    // CodTicketEntregable: codEntregable,
                }),
                method: 'GET',
            })
            !response.isValid && notify(response.exceptions[0].description, 'error');
            setActividadUsuario(response.isValid ? response.content : []);
        }
        catch(e)
        {
            setActividadUsuario([])

        }
    }

    const listaDetallePorTicketActividad = async (codTicketActividad) => {
        try
        {
            const response = await Fetch({
                url: urlProyecto + '/detailTicket?' + new URLSearchParams({
                    CodTicketActividad: codTicketActividad
                }),
                method: 'GET',
            })
            !response.isValid && notify(response.exceptions[0].description, 'error');
            setDetalleTicket(response.isValid ? response.content : []);
        }
        catch(e)
        {
            setDetalleTicket([])
            notify('Ocurrió un error en el servicio','error');
            console.log('Error al listar detalle: ',e)
        }
    }


    return{
        nuevaTarea,
        editarValorNuevaTarea,
        tareas,
        listarTareas,
        editarValorTarea,
        registrarTarea,
        listarTicketEntregable,
        ticketEntregable,
        listaActividadPorUsuario,
        actividadUsuario,
        listaDetallePorTicketActividad,
        detalleTicket
    }
}